export interface IdCardSocketResponse {
  nonce?: string;
  result?: IdCardSessionResultCode;
  finished?: boolean;
}

export enum IdCardSessionResultCode {
  OK = 'OK',
  TIMEOUT = 'TIMEOUT',
  USER_CANCELLED = 'USER_CANCELLED',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
